import Mask from '../../../components/Mask';
import { inject, observer } from 'mobx-react';
import s from './BackModal.module.scss';
import MyIcon from '@/components/MyIcon';
import whenImg from '@/assets/images/simulation/when.webp';
import whatImg from '@/assets/images/simulation/what.webp';
import whereImg from '@/assets/images/simulation/where.webp';
import whoImg from '@/assets/images/simulation/who.webp';
import whyImg from '@/assets/images/simulation/why.webp';
import { factorMapStr } from '@/utils/contants/caseSimulation';
const iconMap = {
    1: whenImg,
    2: whereImg,
    3: whoImg,
    4: whatImg,
    5: whyImg
};
const BackModal = (props) => {
    const { onClose, show } = props;
    let { simulation } = props.store;
    let { background, caseInfo } = simulation;

    return (
        <>
            <Mask show={show}>
                <div className={s.modalWrap}>
                    <div className={s.boxWrap}>
                        <div className={s.title}>
                            <span className={s.roleText}> {caseInfo?.case_title}</span>
                            <span onClick={onClose} className={s.closeIcon}>
                                <MyIcon type="icon-a-guanbi31" />
                            </span>
                        </div>
                        <ul className={s.sectionWrap}>
                            {background?.sections?.map((item, index) => (
                                <li key={index} className={s.sectionItem}>
                                    <div className={s.left}>
                                        <div className={s.icon}>
                                            <img src={iconMap[item?.section_id]} alt="" />
                                        </div>
                                        <div className={s.sectionTitle}>{factorMapStr[item?.section_id] || item?.title}</div>
                                        <div className={s.divider}></div>
                                    </div>
                                    <div className={s.sectionContent}>{item?.content}</div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </Mask>
        </>
    );
};

export default inject('store')(observer(BackModal));
